<template>
  <div id="footer">
    <div class="py-2 px-3 text-right">
      <ul class="list-inline mb-0">
        <li class="list-inline-item">
          <router-link to="/masthead">Impressum</router-link>
        </li>
        <li class="list-inline-item">
          <router-link to="/terms">AGB</router-link>
        </li>
        <li class="list-inline-item">
          <router-link to="/privacy">Datenschutz</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Footer'
  };
</script>

<style scoped lang="scss">
  #footer {
    color: #EEE;
    margin-top: 30px;
    background-color: #494949;

    a {
      color: #EEE;
    }
  }
</style>
